import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Layout, Menu, Button, Avatar, Typography, theme } from "antd";
import {
  HomeOutlined,
  FormOutlined,
  LogoutOutlined,
  UserOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BugOutlined,
} from "@ant-design/icons";
import { useAuth } from "react-oidc-context";

const { Header, Sider, Content } = Layout;
const { Title, Text } = Typography;

const pageTitles: { [key: string]: string } = {
  "/overview": "Overview",
  "/wizards": "Wizard CMS",
  //"/debug": "Auth Debug",
};

const DashboardLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const auth = useAuth();
  const {
    token: { colorBgContainer, colorPrimary },
  } = theme.useToken();

  const handleLogout = () => {
    const clientId = "7gaoa7a5h2vib41nmc8p7k0j5i";
    const logoutUri =
      process.env.NODE_ENV === "development"
        ? "https://localhost:3000"
        : "https://internal.meedloyalty.com";
    const cognitoDomain =
      "https://us-east-1gjxrwtozr.auth.us-east-1.amazoncognito.com";
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri,
    )}`;
  };

  // Determine the selected key based on the current path
  const selectedKey = location.pathname.includes("/wizards")
    ? "/wizards"
    : location.pathname.includes("/debug")
      ? "/debug"
      : "/overview";
  const currentPageTitle = pageTitles[selectedKey] || "Dashboard";

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        theme="dark"
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <div
          style={{
            height: "64px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Title
            level={3}
            style={{
              margin: 0,
              color: "white",
              opacity: collapsed ? 0 : 1,
              transition: "opacity 0.2s",
            }}
          >
            Meed
          </Title>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={[
            {
              key: "/overview",
              icon: <HomeOutlined />,
              label: <Link to="/overview">Overview</Link>,
            },
            {
              key: "/wizards",
              icon: <FormOutlined />,
              label: <Link to="/wizards">Wizard CMS</Link>,
            },
            /* {
              key: "/debug",
              icon: <BugOutlined />,
              label: <Link to="/debug">Auth Debug</Link>,
            }, */
          ]}
        />
      </Sider>
      <Layout
        style={{
          marginLeft: collapsed ? 80 : 200,
          transition: "margin-left 0.2s",
        }}
      >
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: `1px solid ${colorPrimary}`,
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: "16px",
                height: 64,
                padding: "0 24px",
              }}
            />
            <Title level={4} style={{ margin: 0 }}>
              {currentPageTitle}
            </Title>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              paddingRight: "24px",
            }}
          >
            <Avatar icon={<UserOutlined />} style={{ marginRight: 8 }} />
            <Text>{auth.user?.profile.email}</Text>
            <Button
              icon={<LogoutOutlined />}
              onClick={handleLogout}
              style={{ marginLeft: 16 }}
            >
              Logout
            </Button>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px 0", // Removed bottom margin
            padding: 24,
            overflow: "initial",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ background: colorBgContainer, padding: 24, flex: 1 }}>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
